<template>
  <v-list-item
    v-if="show"
    :disabled="disabled"
  >
    <v-list-item-title>
      <font-awesome-icon
        v-if="icon"
        :icon="icon"
      />
      <a
        :href="link"
        :disabled="disabled"
        :class="classes"
        :alt="label"
      >
        {{ label }}
      </a>
    </v-list-item-title>
  </v-list-item>
</template>

<script>
import { formatTemplate } from '../../utils/handlebars'

export default {
  name: 'actions-link-list-it',
  props: {
    action: {
      type: Object,
      required: true
    },
    params: {
      type: Object,
      required: true
    }
  },
  computed: {
    label: function() {
      return this.action.label
    },
    classes: function() {
      const baseClasses = [
        'action-link',
        this.disabled ? 'disabled' : null
      ].filter(_ => _).join(' ')

      if (Object.prototype.hasOwnProperty.call(this.action, 'class')) {
        const params = {
          row: this.params.data,
          rowNumber: this.params.rowIndex + 1,
          preQuery: this.queriesData,
          global: this.globalContext
        }
        return baseClasses + ' ' + formatTemplate(this.action.class, params)
      }
      else {
        return baseClasses
      }
    },
    icon: function() {
      return Object.prototype.hasOwnProperty.call(this.action, 'icon') ? this.action.icon : null
    },
    link: function() {
      const params = {
        row: this.params.data,
        rowNumber: this.params.rowIndex + 1,
        preQuery: this.queriesData,
        global: this.globalContext
      }
      return formatTemplate(this.action.path, params)
    },
    disabled: function() {
      if (this.action.disabled && ['string', 'object'].includes(typeof this.action.disabled)) {
        const params = {
          row: this.params.data,
          rowNumber: this.params.rowIndex + 1,
          preQuery: this.queriesData,
          global: this.globalContext
        }
        const fn = (template) => {
          // eslint-disable-next-line no-new-func
          const func = new Function('context', 'self', template)
          return func(params, this)
        }

        if (typeof this.action.disabled === 'string') {
          return fn(this.action.disabled)
        }
        else {
          const template = this.action.disabled.template

          if (template) {
            if (this.action.disabled.type === 'js') {
              return fn(template)
            }
            else {
              const templateValue = formatTemplate(template, params)
              try {
                const parsedData = JSON.parse(templateValue)
                if (['number', 'boolean'].includes(typeof parsedData)) {
                  return !!parsedData
                }
              }
              catch (e) {
                return false
              }
            }
          }
        }
      }
      return false
    },
    show: function() {
      if (this.action.show && ['string', 'object'].includes(typeof this.action.show)) {
        const params = {
          row: this.params.data,
          rowNumber: this.params.rowIndex + 1,
          preQuery: this.queriesData,
          global: this.globalContext
        }
        const fn = (template) => {
          // eslint-disable-next-line no-new-func
          const func = new Function('context', 'self', template)
          return func(params, this)
        }

        if (typeof this.action.show === 'string') {
          return fn(this.action.show)
        }
        else {
          const template = this.action.show.template

          if (template) {
            if (this.action.show.type === 'js') {
              return fn(template)
            }
            else {
              const templateValue = formatTemplate(template, params)
              try {
                const parsedData = JSON.parse(templateValue)
                if (['number', 'boolean'].includes(typeof parsedData)) {
                  return !!parsedData
                }
              }
              catch (e) {
                return false
              }
            }
          }
        }
      }
      return true
    }
  }
}
</script>

<style lang="scss" scoped>
  .action-link {
    cursor: pointer;
    text-decoration: none;
  }
</style>
